/* eslint-disable */
import styled, { css } from 'styled-components';
import { elevation, elevationTransition, transition } from 'ggApp/utils/mixins';

export const Root = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    transition-property: z-index, opacity, visibility;
    ${({ visible }) => (visible
        ? css`
                  z-index: 5;
                  visibility: visible;
                  opacity: 1;
                  transition-delay: 0ms;
                  ${Background}, ${CloseButton} {
                      opacity: 1;
                      ${transition('opacity', 'long-mobile', 'in')};
                  }
              `
        : css`
                  z-index: -1;
                  visibility: hidden;
                  transition-delay: 300ms;
                  opacity: 0;
              `)};
`;

export const Background = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 5;
    background: rgba(255, 255, 255, 0.9);
    opacity: 0;
    ${transition('opacity', 'long-mobile', 'out')};
`;

export const ImageGallery = styled.div`
    height: 500px;
    z-index: 5;
    position: fixed;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile.max}px) {
        height: 100%;
        width: 100%;
    }
`;

export const ThumbList = styled.ul`
    max-width: 98px;
    margin-right: 16px;
    z-index: 6;
    position: absolute;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin-right: 0;
        position: absolute;
        bottom: 40px;
        left: 50%;
        transform: translateX(-50%);
    `};
`;

export const ThumbImg = styled.img`
    object-fit: contain;
    height: 70px;
    width: 70px;
    vertical-align: top;  /* https://stackoverflow.com/questions/19212352/div-height-based-on-child-image-height-adds-few-extra-pixels-at-the-bottom */
`;

export const ThumbWrap = styled.li`
    border: solid 2px rgba(0, 0, 0, 0);
    border-radius: 10px;
    &:hover {
        border-color: #e1e1e1;
    }
    border-color: ${({ active }) => active && '#e1e1e1'};
    padding: 12px;
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        &:hover {
            border-color: rgba(0, 0, 0, 0);
        }
        padding: 0;
        display: inline-block;
        margin: 0 4px;
        height: 8px;
        width: 8px;
        border-radius: 8px;
        border: 2px solid #989898;
        background: #989898;
        &.active {
            background: none;
            border-color: #e1e1e1;
        }
        ${ThumbImg} {
            display: none;
        }
    `};
`;

export const SliderWrap = styled.div`
    position: fixed;
    -webkit-overflow-scrolling: touch;
    white-space: nowrap;
    max-height: 100vh;
    width: 100vw;
    top: 0;
    transition-duration: 300ms;
    transition-property: transform, opacity;
    transition-timing-function: cubic-bezier(0.23, 1.25, 0.46, 1);
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile.max}px) {
        overflow: hidden;
    }
`;

export const Slider = styled.div`
    position: fixed;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile.max}px) {
        -webkit-overflow-scrolling: touch;
        width: auto;
        position: relative;
    }
`;

export const SlideImage = styled.img`
    height: 100%;
    width: 100%;
    max-height: 100%;
    max-width: 100%;
    object-fit: contain;
    align-self: center;
    ${({ active }) => (active
        ? css`
                  visibility: visible;
                  opacity: 1;
                  transition-property: transform, opacity, visibility;
                  transition-duration: 300ms;
                  transition-timing-function: cubic-bezier(0.23, 1.25, 0.46, 1);
                  will-change: transform;
              `
        : css`
                  visibility: hidden;
                  opacity: 0;
                  transition: none;
              `)};
    top: 0;
    left: 0;
    position: fixed;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile.max}px) {
        width: 100%;
        max-width: 100%;
        max-height: 100%;
        visibility: visible;
        opacity: 1;
        position: relative;
        display: inline-block;
        will-change: transform;
        transform-origin: 0 0 0;
        transition: transform 0ms ease;
        transition-timing-function: cubic-bezier(0.1, 0.57, 0.1, 1);
        transition-duration: 0ms;
        perspective: 1000px;
    }
`;

export const CloseButton = styled.button`
    position: fixed;
    top: 40px;
    left: 50%;
    transform: translateX(-24px);
    border-radius: 50%;
    height: 48px;
    width: 48px;
    background-color: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    ${elevation(0)}
    ${elevationTransition()};
    opacity: 0;
    ${transition('opacity', 'long-mobile', 'out')};
    @media not all and (any-pointer: coarse) {
        &:hover {
            ${elevation(3)};
        }
    }
    &:active {
        ${elevation(1)};
    }
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile.max}px) {
        top: 16px;
        right: 16px;
        transform: unset;
        left: unset;
    }
`;
